import type { SubmissionPatchResponse } from '@ContractBuilder/types';
import { getCurrentDocumentApiUrl } from '@helpers/getCurrentDocumentApiUrl';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type {
  AddBlockFromLibraryApiPayload,
  AddNewCommentApiPayload,
  AddOrRemoveDataSectionsApiPayload,
  ApplyEndorsementDataInput,
  BulkDeleteResourceBlocksApiPayload,
  BulkDeleteSummaryBlocksApiPayload,
  ChangeBaseTemplateApiPayload,
  CreateResourceBlockApiPayload,
  CreateResourceSectionApiPayload,
  DeleteResourceBlockApiPayload,
  DeleteResourceSectionApiPayload,
  PreDraftToDraftApiPayload,
  RecreatePdfWithAttachmentApiPayload,
  RemoveResourceAttachmentApiPayload,
  RenameResourceAttachmentApiPayload,
  ReopenCommentsThreadApiPayload,
  ReorderResourceBlockApiPayload,
  ReorderResourceSectionApiPayload,
  ResolveCommentsThreadApiPayload,
  RestoreEndorsementSummaryTemplateApiPayload,
  SyncSubmissionDataApiPayload,
  UpdateResourceAttachmentStatusApiPayload,
  UpdateResourceBlockApiPayload,
  UpdateResourceDataApiPayload,
  UpdateResourceSectionApiPayload,
} from '@root/@types/payloads';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

type PatchEntityData =
  | AddBlockFromLibraryApiPayload
  | AddNewCommentApiPayload
  | ApplyEndorsementDataInput
  | BulkDeleteResourceBlocksApiPayload
  | BulkDeleteSummaryBlocksApiPayload
  | ChangeBaseTemplateApiPayload
  | CreateResourceBlockApiPayload
  | CreateResourceSectionApiPayload
  | DeleteResourceBlockApiPayload
  | DeleteResourceSectionApiPayload
  | PreDraftToDraftApiPayload
  | RecreatePdfWithAttachmentApiPayload
  | RemoveResourceAttachmentApiPayload
  | RenameResourceAttachmentApiPayload
  | ReorderResourceBlockApiPayload
  | ReorderResourceSectionApiPayload
  | ResolveCommentsThreadApiPayload
  | ReopenCommentsThreadApiPayload
  | RestoreEndorsementSummaryTemplateApiPayload
  | UpdateResourceAttachmentStatusApiPayload
  | UpdateResourceBlockApiPayload
  | UpdateResourceDataApiPayload
  | UpdateResourceSectionApiPayload
  | AddOrRemoveDataSectionsApiPayload
  | SyncSubmissionDataApiPayload;

export const patchEntity: <Response = SubmissionPatchResponse>(
  data: PatchEntityData,
  entityId?: string,
) => Promise<Response> = async (data, entityId) => {
  const url = getCurrentDocumentApiUrl(location.pathname);

  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: entityId ? `${url}/${entityId}` : url,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  return response.data;
};
